<div class="h-screen">
  <div class="bg-(--comp-app-bg)">
    @if (isLoggedIn) {
      <div class="fixed top-0 left-0 w-full z-10">
        <app-header></app-header>
      </div>
    }

    <div class="bg-(--comp-app-bg)" [class]="isLoggedIn ? 'pt-21.75 h-screen' : 'h-screen'">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
